import { styled } from '@mui/material';

import { SimpleStatus } from '@app-velocity/common';

import aiBackground from './ai_bg.png';

const getGradientForStatus = (status?: SimpleStatus | null) => {
  switch (status) {
    case 'pending':
      return 'linear-gradient(50deg, #2c3ce3 0%, #1289D8 100%)';
    case 'success':
      return 'linear-gradient(50deg, #4C9842 0%, #5ac12f 100%)';
    case 'warning':
      return 'linear-gradient(50deg, #DE970B 0%, #FAAD14 100%)';
    case 'error':
      return 'linear-gradient(50deg, #b51919 0%, #db3636 100%)';
    default:
      return 'linear-gradient(50deg, var(--color-neutral-400) 0%, var(--color-neutral-500) 100%)';
  }
};

const StyledBackground = styled('img')({
  position: 'absolute',
  top: 0,
  left: 0,
});

const StyledContainer = styled('div')<{
  status?: SimpleStatus | null;
}>(({ status }) => ({
  background: getGradientForStatus(status),
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  zIndex: -1,
}));

export type StatusBackgroundProps = {
  status: SimpleStatus | null;
  noPattern?: boolean;
};

export const StatusBackground = ({
  status,
  noPattern,
}: StatusBackgroundProps) => {
  return (
    <StyledContainer status={status}>
      {noPattern !== true ? <StyledBackground src={aiBackground} /> : null}
    </StyledContainer>
  );
};
